import * as React from "react";
import styled from "~/styled";

interface IProps {
  actions?: React.ReactNode;
  title: React.ReactNode;
  children: React.ReactNode;
}

const MainLayoutWrapper = styled.div`
  display: grid;
  grid-template-areas:
    "header"
    "content"
    "footer";

  grid-template-rows: auto 1fr auto;
`;

const HeaderWrapper = styled.header`
  grid-area: header;
  text-align: center;
  padding: 0 24px;
`;

const ContentWrapper = styled.main`
  grid-area: content;
  padding: 12px;
  padding-bottom: 100px;
`;

const FooterWrapper = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 24px;
  background: #eee;
  border-top: 1px solid #0002;
  grid-area: footer;
`;

export default class MainLayout extends React.Component<IProps> {
  public render() {
    const { title, children, actions } = this.props;
    return (
      <MainLayoutWrapper>
        <HeaderWrapper>{title}</HeaderWrapper>
        <ContentWrapper>{children}</ContentWrapper>
        <FooterWrapper>{actions}</FooterWrapper>
      </MainLayoutWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/MainLayout.tsx